'use client';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Logo } from 'src/components/logo';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { SIDFOT } from '../landning-innehåll';

const LÄNKAR = [
    { href: paths.presentation.root, text: 'Presentationer' },
    { href: paths.faqs, text: 'Vanliga frågor' },
    { href: paths.villkor, text: 'Användarvillkor' },
    { href: paths.integritetspolicy, text: 'Integritetspolicy' },
    { href: paths.rapporteraProblem, text: 'Rapportera ett problem' },
    { href: paths.LOGGA_IN, text: 'Logga in' }
];

export function Sidfot() {
    return (
        <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider' }}>
            <Container
                maxWidth="lg"
                sx={{
                    py: 5,
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'center' },
                    gap: { xs: 3, md: 5 }
                }}
            >
                <Logo href={paths.landning} sx={{ width: 72, height: 32 }} />
                <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexWrap: 'wrap', gap: { xs: 2, md: 3 } }}>
                    {LÄNKAR.map((l) => (
                        <li key={l.href}>
                            <Link component={RouterLink} href={l.href} variant="body2" color="text.secondary">
                                {l.text}
                            </Link>
                        </li>
                    ))}
                </Box>
                <Box sx={{ ml: { md: 'auto' }, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Link href={`mailto:${SIDFOT.kontakt}`} variant="body2" color="text.primary">
                        {SIDFOT.kontakt}
                    </Link>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        © {new Date().getFullYear()} Flinky
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}
